const profileES = {
    header: {
        title: "Perfil del Negocio",
        preview: "Vista previa",
        edit: "Editar",
    },

    reviews: "Reseñas",

    images: {
        addPhoto: "Agregar foto",
        reviews: "reseñas",
        noPhotos: "Aún no hay fotos",
        needPhoto: "Añade al menos una foto antes de guardar.",
        title: "Imágenes",
        makeCover: "Establecer como portada",
        replace: "Reemplazar",
        delete: "Eliminar",
        cover: "Portada",
        reorderHint: "Mantén presionada una foto y arrástrala para cambiar el orden.",
        noImageSelected: "No hay imagen seleccionada",
        confirmDelete: "¿Estás seguro de que quieres eliminar esta imagen?",
        invalidImage: "Ese archivo no es una imagen válida. Elige una foto (JPG, PNG, etc.).",
        tooLarge: "Esa imagen es demasiado grande (más de 20MB). Elige una foto más pequeña.",
        uploadFailed: "No pudimos subir la imagen. Inténtalo de nuevo.",
        cropTitle: "Recortar foto",
        zoom: "Zoom",
    },

    services: {
        title: "Servicios",
        add: "+ Agregar Servicios",
        empty: "No hay servicios aún.",
        emptyCategory: "Ver o editar servicios",
        name: "Nombre del servicio",
        price: "Precio",
        hours: "Horas",
        minutes: "Minutos",
        description: "Descripción",
        category: "Categoría",

        placeholderName: "Nombre del servicio",
        placeholderDescription: "Descripción del servicio",

        homeService: "A domicilio",
        inShop: "En el local",
        transitTimeLabel: "Tiempo de traslado antes del servicio (minutos)",
    },

    actions: {
        saveChanges: "Guardar cambios",
        cancel: "Cancelar",
    },

    errors: {
        fillAllFields: "Por favor, completa todos los campos obligatorios.",
    },

    /* ───────────── Sidebar ───────────── */
    sidebar: {
        location: {
            title: "Ubicación",
        },
        contact: {
            title: "Contacto",
            phone: "Teléfono",
            email: "Correo electrónico",
            noPhone: "Teléfono no disponible",
            noEmail: "Correo no disponible",
            socialTitle: "Redes sociales",
            website: "Sitio web",
            instagram: "Instagram",
            facebook: "Facebook",
            tiktok: "TikTok",
        },
        hours: {
            title: "Horario de apertura",
            show: "Mostrar más horarios",
            hide: "Ocultar horarios",
            closed: "Cerrado",
            edit: "Editar horario",
        },
        staff: {
            title: "Equipo",
            edit: "Gestionar equipo",
            roles: {
                admin: "Administrador",
                staff: "Empleado",
                owner: "Propietario",
            },
            noStaff: "No hay miembros en el equipo.",
            addStaff: "Invitar miembro",
            remove: "Eliminar",
            editRole: "Cambiar rol",
        },
    },

    /* ───────────── Modales ───────────── */
    modal: {
        shopInfo: {
			intro: "Tu nombre, tu historia y dónde te encuentran los clientes.",
			locationHint:
				"Si ofreces servicios virtuales o a domicilio, ingresa la zona general donde operas.",
            title: "Información del negocio",
            subTitle: "Detalles",
            name: "Nombre del negocio",
            description: "Descripción",
            address: "Dirección",
            city: "Ciudad",
            country: "País",
        },
        contact: {
            title: "Información de contacto",
            description: "Actualiza el teléfono, correo y redes sociales.",
        },
        hours: {
			markOpen: "Marcar abierto",
			markClosed: "Marcar cerrado",
			openCount: "abiertos",
            title: "Horario comercial",
            description: "Configura los horarios de apertura y cierre por día.",
            open: "Abre",
            close: "Cierra",
            closed: "Cerrado",
        },
		services: {
			description: "Agrega, cotiza y organiza todo lo que ofreces.",
		},
		images: {
			description: "Tu primera foto es la portada que ven los clientes.",
		},
		attributes: {
			title: "Atributos del negocio",
			description: "Elige lo que ofrece tu negocio para que los clientes puedan filtrarlo.",
			empty: "No se encontraron atributos.",
			selected: "seleccionados",
		},
		categories: {
			title: "Categorías de servicios",
			description: "Agrupa tus servicios para que el menú sea fácil de leer.",
			empty: "Aún no hay categorías.",
		},
        team: {
            title: "Miembros del equipo",
            description: "Administra los miembros del equipo y sus roles.",
            addButton: "Invitar miembro",
            close: "Cerrar",
            save: "Guardar",
        },
    },

    categories: {
        cannotDeleteWithServices: "Antes de borrar esta categoría, elimina o mueve todos sus servicios.",
        addCategory: "Añadir categoría",
        newCategory: "Nueva categoría",
        categories: "CATEGORIAS",
        missingShop: "No pudimos identificar tu negocio. Inténtalo de nuevo.",
        saveError: "No pudimos guardar los cambios. Inténtalo de nuevo.",
    },

    addAddress: "Agregar dirección",
    addServices: "Editar Servicios",
    footerEmpty: "No hay servicios en esta categoría",
    addFirstServices: "Editar Servicios",
    addShopName: "Agregar nombre del local",
    noReviewsyet: "Todavía no hay reseñas",
    addAttributes: "+ Agregar tus atributos",
    addDescription: "Agrega una breve descripción sobre tu negocio",

    errors: {
        fillAllFields: "Por favor, completa todos los campos obligatorios.",
    },
};

export default profileES;
